document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  var cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  var cartCloseBtn = document.querySelector('[data-cart-close]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartItemsWrapper = document.querySelector('[data-cart-items]');
  var cartSubtotal = document.querySelector('[data-cart-subtotal]');
  var cartCountBadges = document.querySelectorAll('[data-cart-count]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var emptyText = cartDrawer ? cartDrawer.getAttribute('data-empty-text') : '';
  var removeLabel = cartDrawer ? cartDrawer.getAttribute('data-remove-label') : '';
  var continueLabel = cartDrawer ? cartDrawer.getAttribute('data-continue-label') : '';
  var continueUrl = cartDrawer ? cartDrawer.getAttribute('data-continue-url') : '';

  function openCart() {
    body.classList.add('cart-open');
  }

  function closeCart() {
    body.classList.remove('cart-open');
  }

  cartToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });

  if (cartCloseBtn) {
    cartCloseBtn.addEventListener('click', closeCart);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '€' + amount;
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
      });
  }

  function renderCart(cart) {
    cartCountBadges.forEach(function (badge) {
      badge.textContent = cart.item_count;
    });

    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }

    if (cartDrawer) {
      cartDrawer.classList.toggle('cart-drawer--empty', cart.items.length === 0);
    }

    if (!cartItemsWrapper) {
      return;
    }

    if (cart.items.length === 0) {
      cartItemsWrapper.innerHTML =
        '<div class="cart-empty">' +
        '<p class="cart-empty__text">' + emptyText + '</p>' +
        '<a href="' + continueUrl + '" class="cart-empty__btn">' + continueLabel + '</a>' +
        '</div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, index) {
      var lineNumber = index + 1;
      html += '<div class="cart-item" data-cart-line="' + lineNumber + '">';
      html += '<img src="' + item.image + '" alt="' + item.product_title + '" class="cart-item__image" width="70" height="70">';
      html += '<div class="cart-item__details">';
      html += '<p class="cart-item__title">' + item.product_title + '</p>';
      if (item.variant_title) {
        html += '<p class="cart-item__variant">' + item.variant_title + '</p>';
      }
      html += '<div class="cart-item__qty-controls">';
      html += '<button type="button" class="cart-item__qty-btn" data-qty-decrease>&minus;</button>';
      html += '<span class="cart-item__qty" data-qty-value>' + item.quantity + '</span>';
      html += '<button type="button" class="cart-item__qty-btn" data-qty-increase>+</button>';
      html += '</div></div>';
      html += '<div class="cart-item__side">';
      html += '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>';
      html += '<button type="button" class="cart-item__remove" data-cart-remove aria-label="' + removeLabel + '">&times;</button>';
      html += '</div></div>';
    });

    cartItemsWrapper.innerHTML = html;
    bindLineEvents();
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
      });
  }

  function bindLineEvents() {
    var lines = cartItemsWrapper.querySelectorAll('[data-cart-line]');
    lines.forEach(function (lineEl) {
      var lineNumber = parseInt(lineEl.getAttribute('data-cart-line'), 10);
      var qtyValueEl = lineEl.querySelector('[data-qty-value]');

      var increaseBtn = lineEl.querySelector('[data-qty-increase]');
      var decreaseBtn = lineEl.querySelector('[data-qty-decrease]');
      var removeBtn = lineEl.querySelector('[data-cart-remove]');

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var currentQty = parseInt(qtyValueEl.textContent, 10);
          changeLine(lineNumber, currentQty + 1);
        });
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var currentQty = parseInt(qtyValueEl.textContent, 10);
          var newQty = currentQty - 1;
          if (newQty < 0) {
            newQty = 0;
          }
          changeLine(lineNumber, newQty);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          changeLine(lineNumber, 0);
        });
      }
    });
  }

  bindLineEvents();

  document.addEventListener('product:add-to-cart', function (e) {
    var formData = new FormData();
    formData.append('id', e.detail.variantId);
    formData.append('quantity', e.detail.quantity || 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        refreshCart();
        openCart();
      });
  });
});